import { pluralizeNotifications, translateNotifications } from '@geenius/notifications/shared'
import { useCallback } from 'react'

type NotificationParams = Record<string, string | number>

export function useNotificationCopy(): {
  t: (key: string, params?: NotificationParams) => string
  plural: (key: string, count: number, params?: NotificationParams) => string
} {
  const t = useCallback(
    (key: string, params?: NotificationParams) => {
      return translateNotifications(key, params)
    },
    [],
  )

  const plural = useCallback(
    (key: string, count: number, params?: NotificationParams) => {
      return pluralizeNotifications(key, count, params)
    },
    [],
  )

  return { t, plural }
}
